import React from 'react'
import {Spin, Tooltip, message, Space, Button, Select, Input, Modal} from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import PageCommon from  "@components/PageCommon/PageCommon";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import { Link } from "react-router-dom"
import Lang from "@components/Lang/Lang";
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { toFixedWithCommas} from "@utils/number-util";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import dayjs from 'dayjs';
import OrderDetails from '../../../../../components/ModalOrderDetails/OrderDetails/index';
const { Option } = Select;
/**
 * 已出库 页签 | 使用统一的 查询表格组件
 *
 * @author FJJ
 * @version 2.0
 *
 * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version Zhaoruji  => 备份在 index.bak.js
 * 2023      2.0    FJJ
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class OutTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list:[],//行
            extra: {},
            selectOrder:{},
            // 搜索默认
            searchStatus:0,
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'deliveryTime',
                    cnTitle:'',
                    cnTitleId:'',
                    // cnPlaceholder:'客户编号',
                    // cnPlaceholderId:'KeHuBianHao',
                    type:'DateRangePicker',
                    searchRange:['deliveryBeginTime','deliveryEndTime'],
                    width:256,
                },
                {
                    name:'orderNumber',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'DingDanBianHao',
                    width:216,
                },
            ],
            columns:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    dataIndex: 'buyerNumber',
                    render:(text, record, index) => (
                       record.buyerId?<Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{text}</Link>:text
                    ),
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'orderNumber',
                    width: 220,
                    cnTitleId: 'PODingDan',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}
                            {record.noCertificateSplit==1?<Tooltip title={Lang({id: "ZhongGuoZhiFaDingDan",default: "中国直发订单"})}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                            </Tooltip>:null}
                        </p>
                        {record.orderNumber&&<LogisticsAndCabinetSwitch poId = {record.id}
                            poCode={record.orderNumber}
                            containerCode={record.containerCode}
                            cabinetNum={record.cabinetNum}
                            logisticsData={record.pubOrderTrackVOS}
                        />}
                    </>)
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.skuNum}{Lang({id:'Kuan', default:'款'})}，{record.quantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                    <Space direction="vertical ">
                        <div>{record.consignee}</div>
                        <div className="subhead">{record.address}</div>
                    </Space>
                    )
                },
                {
                    cnTitle: '出库仓库',
                    cnTitleId: 'SuoZaiCangKu',
                    dataIndex: 'fromWarehouseName',
                },
                {
                    cnTitle: '出货方式',
                    cnTitleId: 'ChuHuoFangShi',
                    dataIndex: 'deliveryOrderTypeName',
                },
                {
                    cnTitle: '操作人',
                    cnTitleId: 'CaoZuoRen',
                    dataIndex: 'currentUser',
                },
                {
                    cnTitle: '出库时间',
                    cnTitleId: 'ChuKuShiJian',
                    dataIndex: 'time',
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'RuKuShiJian', default: '入库时间'})}>
                                <i className="ri-calendar-check-line mr_6 color-green"></i>
                                {record.deliveryTime ? dayjs(record.deliveryTime).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>
                   </> )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 60,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div >
                        <AuthBtn icon={"ri-article-line"}
                                 tips = {Lang({id:"XiangQing",default:"详情"})}
                                 onClick={()=>this.getDeliveryListInfo(record.id)}/>
                    </div>)},
            ],
            showTip: false,// 批量提示出库提示
        }
        this.intoWarehouseInfo = {}
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 获取单个出库详情*/
    getDeliveryListInfo(id) {
        this.loading(true)
        this.handleCloseDetails(true)
        postDeliveryListInfo({
            id,
        }).then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                let order = res.data.model || {}
                this.setState({
                    selectOrder: {
                        ...order,
                        ids: [order.id],
                    },
                    extra: res.data.extra,
                })
            } else {
                message.info(res.data.message);
            }

        })
    }
    handleCloseDetails(flag=false){
        this.setState({
            showDetails:flag
        })
    }
    setInputKey(key,str){
        let curr = this.state;
        curr[key] = str;
        this.setState(curr)
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    // 查询回调
    fetchCallBack(res){
        this.onRefPageCommonChild.isShowTop()
        const {success,valid,models,model} = res;
        if (success && valid) {
            this.setState({
                list: models
            })
        }else {
            this.setState({
                list: []
            })
        }
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {loading, columns,searchFormOptions, buyerNumber, searchStatus, consignee, showDetails, extra,selectOrder} = this.state;

        return (<PageCommon onRef={this.onRefPageCommon}>
                 <AutoFetchTable columns={columns}
                                 onRef={this.onRefTabOne}
                                 fetchCallBack={(data)=>this.fetchCallBack(data)}
                                topSearchLeftCont={(<Input style={{width:"392px"}}
                                                           className={"mr_12"}
                                                           addonBefore={<Select value={searchStatus} style={{width:"136px"}} onSelect={(value)=>this.setInputKey("searchStatus", value||0)}>
                                                                <Option value={0}>{Lang({id:"KeHuBianHao",default:"客户编号"})}</Option>
                                                                <Option value={1}>{Lang({id:"CaoZuoRen",default:"操作人"})}</Option>
                                                            </Select>}
                                                           placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                                                           onChange={(e)=>this.setInputKey("buyerNumber",e.target.value,)}
                                    />)}
                                flagShowReset={false}
                                precondition={{searchStatus: searchStatus,consignee: consignee,isDelivery:1,buyerNumber:buyerNumber}}
                                pageSize={50}
                                searchFormOptions={searchFormOptions}
                                fetchApi={'/service/mg/delivery-management/delivery-list'} />
                {/*出库详情弹窗*/}
                {showDetails&&<EssaModal title={Lang({id:"DingDanXiangQing",default:"订单详情"})}
                                         open={showDetails}
                                         key={"rx"}
                                         width={750}
                                         onCancel={()=>this.handleCloseDetails()}
                                         footer={[
                                           <Button onClick={() => this.handleCloseDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>,
                                       ]}>
                    <Spin spinning={loading}>
                       {selectOrder&&selectOrder.orderNumber&&extra.currencySymbol&&<OrderDetails
                           data={selectOrder}
                           currencySymbol={extra.currencySymbol} />}
                    </Spin>
                </EssaModal>}
            </PageCommon>
        )
    }
}